import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './assets/css/base.css';
Vue.config.productionTip = false;
// axios引入
import axios from 'axios'
import VueAxios from 'vue-axios'
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return Promise.resolve(response.data);
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});
Vue.use(VueAxios, axios)
// axios引入  end
// 校验引入
import VeeValidate, { Validator } from 'vee-validate';
import zh_CN from 'vee-validate/dist/locale/zh_CN';
Validator.localize('zh_CN', zh_CN);

import * as validate from './assets/js/validator'
Validator.extend('userName', validate.userName);
Validator.extend('phone', validate.phone);

Vue.use(VeeValidate, {
  errorBagName: 'errors', // change if property conflicts.
  delay: 0,
  locale: 'zh_CN',
  strict: false,
});
// 校验   end
// vant引入
import { Toast, Swipe, SwipeItem, Actionsheet } from 'vant';
import 'vant/lib/index.css';
Vue.use(Toast).use(Swipe).use(SwipeItem).use(Actionsheet);
// vant引入  end
// 路由判断
router.beforeEach(async (to, from, next) => {
  if (
    (to.name == "two" && typeof store.state.testData[0] == "undefined")
    || (to.name == "three" && typeof store.state.testData[1] == "undefined")
    || (to.name == "four" && typeof store.state.testData[2] == "undefined")
    || (to.name == "testResult" && store.state.testData.length != 4)
    || (from.name == "testResult" && /\/test\//.test(to.path))
    || (from.name == "result" && to.name == "upload")
  ) {
    next("/index");
    return
  }
  next()
})
// 路由判断  end
// 获取缓存
const selectData = sessionStorage.getItem("sl");
selectData && store.commit("setStoreData", {
  name: "testData",
  data: JSON.parse(selectData)
});
// 获取缓存  end

// import VConsole from 'vconsole';
// var vConsole = new VConsole();
window.addEventListener("click", function (e) {
  const clickname = e.target.dataset.name;
  if (clickname) {
    axios.post(
      "http://wine.koyooo.com/phone/tracking.html",
      "clickevent=" + clickname
    );
  }
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
